// src/experiments/double-duration.mjs

import { Duration } from 'luxon';

/**
 * @type {Experiment}
 */
export const DoubleDurationExperiment = {
  id: 'double-duration',
  type: 'recurrence',
  name: 'Dobbelt gentagelsesvirkning. Kun ordinær gentagelse',
  exclusive: false,
  allowMultiple: false, // 🚨 Tillader eksplicit IKKE at køre flere gange!
  
  /**
   * @param {AppState} appState 
   * @returns {void}
   */
  init(appState) {
    console.log('[Eksperiment] Aktiveret: Dobbelt gentagelsesvirkning. Kun ordinær gentagelse...');
    
    // Registrer en ændring på featuren 'duration:alter'
    appState.registerModifier('duration:alter',
      /**
       * @param {PeriodDuration} originalDuration
       * @param {boolean} isSpecialRecurrence
       * @returns {PeriodDuration}
       */
      (originalDuration, isSpecialRecurrence) => {

      if (isSpecialRecurrence) {
        return originalDuration;
      }

      return /** @type {PeriodDuration} */ (
        Duration.fromObject(originalDuration)
          .plus(originalDuration)
          .toObject()
      );

    });
  }
};